/* =========================================================
   Pure Luna Product Page — vanilla JS, modular, no globals
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------------- Gallery ---------------- */
  function initGallery(root) {
    var track = root.querySelector('[data-pl-gallery-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pl-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pl-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pl-dot]'));
    var counter = root.querySelector('[data-pl-gallery-counter]');
    var prevBtn = root.querySelector('[data-pl-gallery-prev]');
    var nextBtn = root.querySelector('[data-pl-gallery-next]');
    if (!slides.length) return;

    function showByMediaId(mediaId) {
      var index = 0;
      slides.forEach(function (slide, i) {
        var match = slide.getAttribute('data-media-id') === String(mediaId);
        slide.classList.toggle('is-active', match);
        if (match) index = i;
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(mediaId));
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      if (counter) counter.textContent = (index + 1) + '/' + slides.length;

      if (window.matchMedia('(max-width: 989px)').matches && track) {
        var target = slides[index];
        if (target) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showByMediaId(thumb.getAttribute('data-media-id'));
      });
    });

    function step(dir) {
      var activeIndex = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      var nextIndex = (activeIndex + dir + slides.length) % slides.length;
      showByMediaId(slides[nextIndex].getAttribute('data-media-id'));
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    /* mobile swipe -> update active dot/counter on scroll end */
    if (track) {
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var closest = slides.reduce(function (best, slide) {
            var diff = Math.abs(slide.offsetLeft - track.scrollLeft);
            return diff < best.diff ? { diff: diff, slide: slide } : best;
          }, { diff: Infinity, slide: slides[0] }).slide;
          showByMediaId(closest.getAttribute('data-media-id'));
        }, 80);
      });
    }

    root.__plShowByMediaId = showByMediaId;
  }

  /* ---------------- Product form: variants, quantity, price sync ---------------- */
  function initProductForm(section) {
    var wrapper = section.querySelector('[data-pl-product-form-wrapper]');
    var jsonEl = section.querySelector('[data-pl-product-json]');
    var galleryRoot = section.querySelector('[data-pl-gallery]');
    if (!wrapper || !jsonEl) return;

    var data = JSON.parse(jsonEl.textContent);
    var options = data.options;
    var variants = data.variants;

    var pillGroups = Array.prototype.slice.call(wrapper.querySelectorAll('[data-pl-option]'));
    var variantIdInput = wrapper.querySelector('[data-pl-variant-id]');
    var addToCartBtn = wrapper.querySelector('[data-pl-add-to-cart]');
    var addToCartText = wrapper.querySelector('[data-pl-add-to-cart-text]');
    var availabilityEl = wrapper.querySelector('[data-pl-availability]');
    var priceCurrent = section.querySelector('[data-pl-price-current]');
    var priceCompare = section.querySelector('[data-pl-price-compare]');
    var priceSave = section.querySelector('[data-pl-price-save]');
    var qtyInput = wrapper.querySelector('[data-pl-qty-input]');
    var qtyMinus = wrapper.querySelector('[data-pl-qty-minus]');
    var qtyPlus = wrapper.querySelector('[data-pl-qty-plus]');

    function getSelectedOptions() {
      return pillGroups.map(function (group) {
        var selected = group.querySelector('.pl-form__pill.is-selected');
        return selected ? selected.getAttribute('data-value') : null;
      });
    }

    function findMatchingVariant(selected) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function formatMoney(cents) {
      // Basic fallback formatter; theme's Shopify.formatMoney used when available.
      if (window.Shopify && window.Shopify.formatMoney && window.themeMoneyFormat) {
        return window.Shopify.formatMoney(cents, window.themeMoneyFormat);
      }
      return (cents / 100).toFixed(2);
    }

    function updateUI(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceCompare) priceCompare.style.display = hasCompare ? '' : 'none';
      if (priceCompare && hasCompare) priceCompare.textContent = formatMoney(variant.compare_at_price);
      if (priceSave) priceSave.style.display = hasCompare ? '' : 'none';
      if (priceSave && hasCompare) priceSave.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price);

      if (addToCartBtn) addToCartBtn.disabled = !variant.available;
      if (addToCartText) addToCartText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      if (availabilityEl) {
        availabilityEl.innerHTML = variant.available
          ? '<span class="pl-form__in-stock">In stock, ready to ship</span>'
          : '<span class="pl-form__out-stock">Currently sold out</span>';
      }

      if (galleryRoot && galleryRoot.__plShowByMediaId && variant.featured_media_id) {
        galleryRoot.__plShowByMediaId(variant.featured_media_id);
      }

      var stickyBar = document.querySelector('[data-pl-sticky-cart]');
      if (stickyBar) {
        var stickyPrice = stickyBar.querySelector('[data-pl-sticky-price]');
        var stickyBtn = stickyBar.querySelector('[data-pl-sticky-add-to-cart]');
        var stickyText = stickyBar.querySelector('[data-pl-sticky-btn-text]');
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        if (stickyBtn) stickyBtn.disabled = !variant.available;
        if (stickyText) stickyText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    }

    pillGroups.forEach(function (group) {
      var pills = Array.prototype.slice.call(group.querySelectorAll('[data-pl-option-value]'));
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          var selected = getSelectedOptions();
          var matched = findMatchingVariant(selected);
          if (matched) updateUI(matched);
        });
      });
    });

    // Expose so the pack-tier selector (a separate init function) can select
    // a real variant by ID and get the exact same price/availability sync.
    wrapper.__plUpdateUIById = function (variantId) {
      var match = variants.find(function (v) { return String(v.id) === String(variantId); });
      if (match) updateUI(match);
    };

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = val;
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var val = (parseInt(qtyInput.value, 10) || 1) + 1;
        qtyInput.value = val;
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var val = parseInt(qtyInput.value, 10);
        if (!val || val < 1) qtyInput.value = 1;
      });
    }

    /* Sticky mobile add-to-cart delegates to the real form's submit button */
    var stickyBtn = document.querySelector('[data-pl-sticky-add-to-cart]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (addToCartBtn) addToCartBtn.click();
      });
    }
  }

  /* ---------------- Sticky mobile cart visibility ---------------- */
  function initStickyCartVisibility() {
    var stickyBar = document.querySelector('[data-pl-sticky-cart]');
    var mainForm = document.querySelector('[data-pl-add-to-cart]');
    if (!stickyBar || !mainForm || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var visible = !entry.isIntersecting;
        stickyBar.hidden = false;
        stickyBar.setAttribute('data-visible', visible ? 'true' : 'false');
      });
    }, { threshold: 0 });

    observer.observe(mainForm);
  }

  /* ---------------- FAQ accordion ---------------- */
  function initFaq(root) {
    var allowMultiple = root.getAttribute('data-allow-multiple') === 'true';
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-pl-faq-trigger]'));

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        if (!allowMultiple) {
          triggers.forEach(function (t) {
            if (t !== trigger) {
              t.setAttribute('aria-expanded', 'false');
              var p = document.getElementById(t.getAttribute('aria-controls'));
              if (p) p.hidden = true;
            }
          });
        }

        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (panel) panel.hidden = isOpen;
      });
    });
  }

  /* ---------------- Marquee pause-on-hover ---------------- */
  function initMarquee(root) {
    var viewport = root.querySelector('[data-pl-marquee]');
    if (!viewport) return;
    var pauseAttr = root.closest('[data-pl-scheme]');
    viewport.addEventListener('mouseenter', function () {
      viewport.setAttribute('data-pl-marquee-paused', 'true');
    });
    viewport.addEventListener('mouseleave', function () {
      viewport.setAttribute('data-pl-marquee-paused', 'false');
    });
  }

  /* ---------------- Scroll-reveal animation ---------------- */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;
    var selectors = [
      '.pl-section-head', '.pl-story__content', '.pl-story__image', '.pl-story__cards',
      '.pl-trust__item', '.pl-benefits__card', '.pl-howto__card', '.pl-howto__photo-card',
      '.pl-howto__cta', '.pl-ingredients__card', '.pl-ingredients__pbn-col', '.pl-ingredients__pbn-center',
      '.pl-testimonials__card', '.pl-faq__item', '.pl-ugc__card', '.pl-card', '.pl-reels__card',
      '.pl-banner__inner', '.pl-lifestyle__inner'
    ];
    var els = document.querySelectorAll(selectors.join(','));
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pl-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el, i) {
      el.classList.add('pl-reveal');
      el.style.transitionDelay = (i % 6) * 60 + 'ms';
      observer.observe(el);
    });
  }

  /* ---------------- Reels ---------------- */
  function initReels(root) {
    var autoplayInView = root.getAttribute('data-autoplay-in-view') === 'true';
    var row = root.querySelector('[data-pl-reels-row]');
    var prevBtn = root.querySelector('[data-pl-reels-prev]');
    var nextBtn = root.querySelector('[data-pl-reels-next]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pl-reel]'));

    function pauseAll(except) {
      cards.forEach(function (card) {
        if (card === except) return;
        var v = card.querySelector('video');
        if (v && !v.paused) { v.pause(); card.setAttribute('data-playing', 'false'); }
      });
    }

    cards.forEach(function (card) {
      var video = card.querySelector('video');
      var playBtn = card.querySelector('[data-pl-reel-play]');
      var muteBtn = card.querySelector('[data-pl-reel-mute]');
      if (!video) return;

      video.muted = true;
      if (muteBtn) muteBtn.setAttribute('data-muted', 'true');

      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (video.paused) {
            pauseAll(card);
            video.play();
            card.setAttribute('data-playing', 'true');
          } else {
            video.pause();
            card.setAttribute('data-playing', 'false');
          }
        });
      }

      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          video.muted = !video.muted;
          muteBtn.setAttribute('data-muted', video.muted ? 'true' : 'false');
        });
      }
    });

    if (autoplayInView && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var card = entry.target;
          var video = card.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            pauseAll(card);
            video.play().then(function () {
              card.setAttribute('data-playing', 'true');
            }).catch(function () {});
          } else {
            video.pause();
            card.setAttribute('data-playing', 'false');
          }
        });
      }, { threshold: [0, 0.6, 1] });

      cards.forEach(function (card) {
        if (card.querySelector('video')) observer.observe(card);
      });
    }

    function scrollByCard(dir) {
      if (!row) return;
      var card = row.querySelector('.pl-reels__card');
      var amount = card ? card.getBoundingClientRect().width + 16 : 220;
      row.scrollBy({ left: amount * dir, behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
  }

  /* ---------------- Pack tier selector ---------------- */
  function initPackTiers(section) {
    var wrapper = section.querySelector('[data-pl-pack-tiers]');
    if (!wrapper) return;
    var formWrapper = section.querySelector('[data-pl-product-form-wrapper]');
    var options = Array.prototype.slice.call(wrapper.querySelectorAll('[data-pl-pack-option]'));
    var qtyInput = section.querySelector('[data-pl-qty-input]');

    options.forEach(function (option) {
      if (option.classList.contains('pl-form__pack-card--unavailable')) return;

      option.addEventListener('click', function () {
        options.forEach(function (o) {
          o.classList.remove('is-selected');
          var r = o.querySelector('[data-pl-pack-radio]');
          if (r) r.checked = false;
        });
        option.classList.add('is-selected');
        var radio = option.querySelector('[data-pl-pack-radio]');
        if (radio) radio.checked = true;

        var variantId = option.getAttribute('data-pl-pack-variant-id');
        if (variantId && formWrapper && formWrapper.__plUpdateUIById) {
          // Real Shopify variant: syncs price, compare-at, availability and
          // the hidden variant id used at checkout — single source of truth.
          formWrapper.__plUpdateUIById(variantId);
          if (qtyInput) qtyInput.value = 1;
        } else {
          // Fallback path for packs with no matching variant configured:
          // just bumps quantity of the single default variant.
          var qty = parseInt(option.getAttribute('data-quantity'), 10) || 1;
          if (qtyInput) qtyInput.value = qty;
        }
      });
    });
  }

  /* ---------------- Recommendations carousel arrows ---------------- */
  function initRecommendationsCarousel(root) {
    var grid = root.querySelector('[data-pl-recommendations-grid]');
    var prevBtn = root.querySelector('[data-pl-rec-prev]');
    var nextBtn = root.querySelector('[data-pl-rec-next]');
    if (!grid) return;

    function scrollByCard(dir) {
      var card = grid.querySelector('.pl-card');
      var amount = card ? card.getBoundingClientRect().width + 20 : 260;
      grid.scrollBy({ left: amount * dir, behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
  }

  /* ---------------- Recommendations fetch (fallback for cached sections) ---------------- */
  function initRecommendations(root) {
    var grid = root.querySelector('[data-pl-recommendations-grid]');
    if (!grid || grid.children.length > 0) return;
    var url = root.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-pl-recommendations-grid]');
        if (newGrid && newGrid.innerHTML.trim()) grid.innerHTML = newGrid.innerHTML;
      })
      .catch(function () { /* fail silently, section just stays empty */ });
  }

  /* ---------------- Boot ---------------- */
  document.querySelectorAll('[data-pl-gallery]').forEach(initGallery);
  document.querySelectorAll('[data-pl-main-product]').forEach(initProductForm);
  document.querySelectorAll('[data-pl-faq]').forEach(initFaq);
  document.querySelectorAll('[data-pl-recommendations]').forEach(initRecommendations);
  document.querySelectorAll('[data-pl-recommendations]').forEach(initRecommendationsCarousel);
  document.querySelectorAll('[data-pl-main-product]').forEach(initPackTiers);
  document.querySelectorAll('[data-pl-marquee]').forEach(function (v) { initMarquee(v.closest('section')); });
  document.querySelectorAll('.pl-section-reels').forEach(initReels);
  document.querySelectorAll('[data-pl-reels]').forEach(initReels);
  initScrollReveal();
  initStickyCartVisibility();
});
